import { render } from "./ListePays.vue?vue&type=template&id=1d1c3cd6"
import script from "./ListePays.vue?vue&type=script&lang=js"
export * from "./ListePays.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__